const SubmitButton = {
  name: "SubmitButton",
  label: "{{nextLabel}}", //TODO
  type: "submit",
  component: "ButtonField",
  block: false,
};
export default SubmitButton;
